import * as React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';


const useStyles = makeStyles((theme) => ({
  LoadingButton: {
    width: '100%',
    borderRadius: `${theme.borderRadius.small}px !important`,
    '&[id]': {
      pointerEvents: 'auto',
      '& *': {
        pointerEvents: 'none',
      }
    },
    '&.main': {
      boxShadow: theme.palette.shadow.main,
      transition: '.5s',
      '&:hover': {
        boxShadow: 'none',
      },
      '&.primary': {
        backgroundImage: theme.button.backgroundImage,
        backgroundSize: '200% auto',
        '&:hover': {
          backgroundPosition: 'right center',
        },
      },
      '&.red': {
        backgroundColor: theme.palette.primary.red,
        '&:hover': {
          backgroundColor: theme.palette.primary.red,
        }
      },
      '&.white': {
        color: theme.palette.text.main,
        border: `1px solid ${theme.palette.line.dark}`,
        backgroundColor: theme.palette.background.paper,
        boxShadow: 'none',
        '&:hover': {
          backgroundColor: theme.palette.background.containerHover,
        }
      },
      '&.brand': {
        color: theme.palette.background.paper,
        border: `1px solid ${theme.palette.button.regular}`,
        backgroundColor: theme.palette.button.regular,
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none',
          border: `1px solid ${theme.palette.button.hover}`,
          backgroundColor: theme.palette.button.hover,
        }
      },
    },
    '&.outlined': {
      '&.primary': {
        border: `2px solid ${theme.palette.primary.main}`,
        backgroundColor: theme.palette.background.paper,
        boxShadow: 'none',
        [theme.breakpoints.down('sm')]: {
          border: `1px solid ${theme.palette.primary.main}`,
        },
        '&:hover': {
          backgroundColor: theme.palette.background.hover,
        },
      },
      '&.red': {
        border: `2px solid ${theme.palette.primary.red}`,
        backgroundColor: theme.palette.background.paper,
        boxShadow: 'none',
        [theme.breakpoints.down('sm')]: {
          border: `1px solid ${theme.palette.primary.red}`,
        },
        '&:hover': {
          backgroundColor: theme.palette.background.hover,
        },
      },
      '&.white': {
        color: theme.palette.text.secondary,
        border: `1px solid ${theme.palette.line.input}`,
        backgroundColor: theme.palette.background.paper,
        boxShadow: 'none',
        '&:hover': {
          color: theme.palette.text.main,
          boxShadow: 'none',
          backgroundColor: theme.palette.background.hover,
        }
      },
    },
  },
  page: {
    width: '50%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  full: {
    width: '100%',
  },
  text: {
    fontSize: 16,
    fontWeight: 700,
  },
  disabled: {
    '& button.MuiButton-root.Mui-disabled': {
      color: theme.palette.text.note,
      background: theme.palette.background.radiusBtnHover,
      backgroundImage: 'none',
    }
  },
}));


/**
 * 送出按鈕
 * content 內容
 * onClick click動作
 * color 顏色：預設、red、white
 * loading 處理中
 * type 寛度
 *   page 頁面寛
 *   full 全寛
 * variant 樣式
 * disabled 禁用
 */
export function ButtonCom({ content, onClick, color, loading, type, variant = null, disabled = false, id = null }) {

  const classes = useStyles();


  return (
    <Box className={clsx(type === 'page' ? classes.page : classes.full, { [classes.disabled]: disabled })} mb={type === 'page' ? 12 : 0}>
      <LoadingButton
        id={id}
        className={clsx(classes.LoadingButton, variant ? variant : 'main', color ? color : 'primary')}
        onClick={onClick}
        loading={loading}
        variant={variant ? variant : 'contained'}
        disabled={disabled}
      >
        <Box className={classes.text}>{loading ? '　' : content}</Box>
      </LoadingButton>
    </Box>
  )
}